module.exports = __webpack_public_path__ + "media/images/mediaLink-7edfa8a2e1cba1de54dd2fbdd217091c.svg";